import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import Checkbox from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Checkbox';
import { FormControlLabel } from '@material-ui/core';
import Typography from 'Components/UI/Typography';

const CustomCheckBox = withStyles(theme => ({
  root: {
    color: theme.palette.facet.accentBlue21,
    '&:not($checked) .MuiIconButton-label': {
      backgroundColor: theme.palette.facet.accentBlue21,
      borderRadius: theme.radius.xs,
    },
    '&$checked': {
      color: theme.palette.facet.primaryBlue,
    },
    '&$checked .MuiIconButton-label': {
      backgroundColor: theme.palette.facet.accentBlue21,
      borderRadius: theme.radius.xs,
    },
    '&.MuiIconButton-label': {
      backgroundColor: theme.palette.facet.accentBlue21,
      borderRadius: theme.radius.xs,
    },
  },
  checked: {},
}))((props) => <Checkbox {...props} />);

// CheckboxYesNo Styles
const styles = (theme) => ({
  root: {},
  formControlLabel: {
    color: theme.palette.facet.primaryBlue,
    fontSize: theme.typography.h4.fontSize,
    fontWeight: theme.typography.fontWeightMedium,
  },
  checkboxRoot: {
    backgroundColor: 'transparent',
  },
  checkedLabelContainer: {
    backgroundColor: theme.palette.secondary.main,
    padding: theme.spacing(0.5, 2),
    borderRadius: theme.radius.md,
  },
  uncheckedLabelContainer: {
    backgroundColor: theme.palette.warning.main,
    padding: theme.spacing(0.5, 2),
    borderRadius: theme.radius.md,
  },
  checkedLabel: {
    color: theme.palette.common.white,
  },
  uncheckedLabel: {
    color: theme.palette.common.white,
  },
});

const CheckboxYesNo = ({
  className,
  classes,
  hidden,
  label,
  value,
  helperText,
  readonly,
  ...rest
}) => {
  let isChecked = value;
  if (typeof value === 'string') {
    isChecked = value.toLowerCase() === 'true' || value.toLowerCase() === 'enabled' || value.toLowerCase() === 'yes';
  }

  function getLabel(v) {
    if (v.toLowerCase() === 'true') return 'Yes';
    if (v.toLowerCase() === 'false') return 'No';
    return value;
  }

  return (
    <FormControlLabel
      label={label}
      className={classNames(classes.root, className)}
      classes={{
        label: classes.formControlLabel,
      }}
      control={
        <CustomCheckBox
          classes={{
            checked: classes.checkboxRoot,
            root: classes.checkboxRoot,
          }}
          className={classes.checkbox}
          variant={'outlined'}
          checked={isChecked}
          checkedIcon={(
            <div className={classes.checkedLabelContainer}>
              <Typography
                className={classes.checkedLabel}
              >
                {getLabel(value)}
              </Typography>
            </div>
          )}
          icon={(
            <div className={classes.uncheckedLabelContainer}>
              <Typography
                className={classes.uncheckedLabel}
              >
                {getLabel(value)}
              </Typography>
            </div>
          )}
          {...rest}
        />
      }
      disabled={readonly}
      hidden={hidden}
    />
  );
};

CheckboxYesNo.defaultProps = {
  className: '',
  readonly: false,
};

CheckboxYesNo.propTypes = {
  classes: PropTypes.object.isRequired,
  className: PropTypes.string,
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired,
  readonly: PropTypes.bool,
};

export default withStyles(styles, { name: 'Checkbox' })(CheckboxYesNo);
